import StyledTableCell from "@components/Table/TableCell";
import { CSSProperties, Switch, TextField } from "@mui/material";
import { ClientModelVariable } from "@services/api/types";
import { IVariableValues } from "@utils/external_effects";

export interface IExternalVarCell {
  componentId: string;
  timePeriod: string;
  modelVar: ClientModelVariable;
  extVariableValues: IVariableValues;
  setExtVariableValues: (extVariableValues: IVariableValues) => void;
  style?: CSSProperties;
  enabled: boolean;
}

const ExternalVarCell = ({
  componentId,
  timePeriod,
  modelVar,
  extVariableValues,
  setExtVariableValues,
  style,
  enabled
}: IExternalVarCell) => {
  const isInputType = modelVar.input_type === "input";
  const externalVarValue = extVariableValues[timePeriod]?.[modelVar.id] || 0;

  return (
    <StyledTableCell
      align="center"
      key={`${componentId}-external-var-row-${timePeriod}-${modelVar.id}`}
      style={style}
    >
      {isInputType && (
        <TextField
          type="number"
          variant="outlined"
          value={externalVarValue}
          disabled={!enabled}
          InputProps={{
            inputProps: {
              min: 0
            }
          }}
          onChange={(event) => {
            extVariableValues[timePeriod][modelVar.id] = Number(
              event.target.value as string
            );
            setExtVariableValues({ ...extVariableValues });
          }}
          required
        />
      )}
      {!isInputType && (
        <Switch
          checked={externalVarValue > 0}
          color="info"
          disabled={!enabled}
          onChange={(event) => {
            extVariableValues[timePeriod][modelVar.id] = event.target.checked
              ? 1
              : 0;
            setExtVariableValues({ ...extVariableValues });
          }}
        />
      )}
    </StyledTableCell>
  );
};

export default ExternalVarCell;
